import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";
export type PortfolioAssignedUser = {
  portfolioAssignUsersId: string;
  portfolioId: string;
  assignedToUserId: string;
  portfolioRole: string;
  user: {
    userId: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    avatarImg?: string | null;
  };
};

export type ProgramAssignedUser = {
  programAssignUsersId: string;
  programId: string;
  assignedToUserId: string;
  programRole: string;
  user: {
    userId: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    avatarImg?: string | null;
  };
};

export type Portfolios = {
  portfolioId: string;
  organisationId: string;
  portfolioName: string;
  programs: Program[];
  assignedUsers?: PortfolioAssignedUser[];
};

export interface Program {
  programId: string;
  portfolioId: string | null;
  programName: string;
  assignedUsers?: ProgramAssignedUser[];
}
  
export type PortfoliosResponse = ResponseType<{programs:Program[],portfolios:Portfolios[]}>;

function useAllPortfoliosQuery(enabled = true, managedOnly = false) {
  return useQuery<
    AxiosResponseAndError<PortfoliosResponse>["response"],
    AxiosResponseAndError<PortfoliosResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.portfolios, managedOnly],
    queryFn: async () =>
      await ApiRequest.get(requestURLs.project + "/portfolios", {
        params: { managedOnly },
      }),
    enabled: enabled,
  });
}

export default useAllPortfoliosQuery;
